document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".block__our-expertise-acc");

  function setupAccordionBehavior() {
    accordionItems.forEach((item) => {
      const answer = item.querySelector(".block__our-expertise-answer");
      const icon = item.querySelector(".block__our-expertise-acc-icon");

      // Initial state setup
      if (item.classList.contains("active")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.overflow = "hidden";
        icon.style.transform = "rotate(180deg)";
        item.closest(".block__our-expertise-acc-main")?.classList.add("accordion-open");
      } else {
        answer.style.maxHeight = "0";
        answer.style.overflow = "hidden";
        icon.style.transform = "rotate(0deg)";
      }

      // Remove any existing listener to avoid duplicates
      item.removeEventListener("click", handleClick);
      item.addEventListener("click", handleClick);

      function handleClick(event) {
        event.stopPropagation();

        const accMain = item.closest(".block__our-expertise-acc-main");

        // Close other accordion items
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("active")) {
            otherItem.classList.remove("active");
            otherItem.querySelector(".block__our-expertise-answer").style.maxHeight = "0";
            otherItem.querySelector(".block__our-expertise-acc-icon").style.transform = "rotate(0deg)";
            otherItem.closest(".block__our-expertise-acc-main")?.classList.remove("accordion-open");
          }
        });

        // Toggle current accordion item
        if (item.classList.contains("active")) {
          item.classList.remove("active");
          answer.style.maxHeight = "0";
          icon.style.transform = "rotate(0deg)";
          accMain?.classList.remove("accordion-open");
        } else {
          item.classList.add("active");
          answer.style.maxHeight = answer.scrollHeight + "px";
          icon.style.transform = "rotate(180deg)";
          accMain?.classList.add("accordion-open");
        }
      }

      // Resize handler
      window.addEventListener('resize', () => {
        if (item.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  }

  setupAccordionBehavior();
});
